import { render, staticRenderFns } from "./InputGroup.vue?vue&type=template&id=71d279a3&scoped=true&"
import script from "./InputGroup.vue?vue&type=script&lang=js&"
export * from "./InputGroup.vue?vue&type=script&lang=js&"
import style0 from "./InputGroup.vue?vue&type=style&index=0&id=71d279a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d279a3",
  null
  
)

export default component.exports